
import { Patients } from './patients';
import { Users } from './users';
import { Personnel } from './personnel';


 export class Ephemeride{ 
    id: number;
    type: string;
    titre: string;
    description: string;
    etat: boolean;
    date: any;
    createur: Users;
    /*cible:string;*/
    cible:Personnel;
/*
    patient: Patients;
    
*/
}


// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/ephemeride.ts